<template>
    <div v-show="!showRacAberura && !modoEdicao && !modoConferencia">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption">S.I.M.</label>
                <div class="field-label">{{ globalStore.nmsim }}</div>
            </div>

            <div v-if="globalStore.nmestabelecimento" class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
            
            <button type="button" class="btn-small" @click="lerDados">Ler Dados</button>
            <button type="button" class="btn-small" @click="closeForm">Voltar</button>
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Referência</th>
                        <th>Protocolo</th>
                        <th>N/C</th>
                        <th>Prazo</th>
                        <th>Situação</th>
                        <th>Data/Hora Digitação</th>
                        <th>Protocolo RAC</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in lsDados" :key="item.id" @click="onClickItem(item)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td>{{ item.ref_titulo }}</td>
                    <td class="col-width-char20">{{ item.ref_protocolo }}</td>
                    <td class="col-width-char05 center">{{ Funcoes.formatInteger(item.qtdnc) }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(item.dtprazo) }}</td>
                    <td class="col-width-char30">{{ item.nmstatus }}</td>
                    <td class="col-width-char30 center">{{ Funcoes.formatDateTimeFromJson(item.dhdigitacao) }}</td>
                        <td class="col-width-char30">{{ item.protocolo }}</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>
    
    
    <template v-if="modoEdicao">
        <RacEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </template>
    

    <div v-if="showRacAberura" class="rac-abertura">
        <div class="rac-header">
            <div class="rac-header-icon">⚠️</div>
            <div>
                <h2>CONFIRMAR ABERTURA DE RAC</h2>

                <div class="row-start row-space">
                    <button
                        type="button"
                        class="btn-small"
                        @click="onClickIniciar"
                    >
                        Iniciar RAC
                    </button>

                    <button
                        type="button"
                        class="btn-small"
                        @click="showRacAberura = false"
                    >
                        Voltar
                    </button>
                </div>
                
                <p>
                    As não conformidades abaixo serão vinculadas a uma nova
                    <strong>RAC - Relatório de Ação Corretiva</strong>.
                    Confirme para iniciar o processo.
                </p>
            </div>
        </div>

        <div class="rac-grid">
            <div
                v-for="item in lsNc"
                :key="item.id"
                class="rac-card"
            >
                <div class="rac-card-header">
                    <div class="rac-card-codigo">
                        {{ item.ref_cditem }}
                    </div>

                    <div class="rac-card-titulo">
                        {{ item.ref_nmitem }}
                    </div>
                </div>

                <textarea
                    v-model="item.ref_nc"
                    rows="6"
                    readonly
                    class="rac-textarea"
                />
            </div>
        </div>
    </div>


    <AssinaturaPendenteListaModal
        v-if="showModalAssinaturas"
        :refId="objSelecionado.idrac"
        :refTable="'RAC'"
        @close="showModalAssinaturas = false"
    />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import AssinaturaPendenteListaModal from '@/components/modals/AssinaturaPendenteListaModal.vue';
import RacEditPage from '../formularios/RacEditPage.vue';

const emit = defineEmits(['close']);
const idEdicao = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const lsNc = ref([]);
const modoConferencia = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const objSelecionado = ref(null);
const showRacAberura = ref(false);
const showModalAssinaturas = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: globalStore.idestabelecimento};
        const req = await Api.genericPost('/dados/rac/pendentes', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


async function onClickIniciar(){
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        
        const rAdd = await Api.genericPost('/pla/exec_requisicao', {
            nmrequisicao: 'rac_abertura',
            idep: globalStore.idep,
            idlogin: globalStore.idlogin,
            strparam1: objSelecionado.value.ref_tabela,
            idreferencia: objSelecionado.value.ref_id});
        if (rAdd.bolok==1){
            idEdicao.value = rAdd.id;
            showRacAberura.value = false;
            modoEdicao.value = true;
        }else{throw new Error(rAdd.erro)}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function onClickItem(obj){
    if (obj.idrac && obj.cdstatus != 1){
        objSelecionado.value = obj;
        showModalAssinaturas.value=true;
        return;
    }
    
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        if (!obj.idrac){
            objSelecionado.value = obj;

            const rNc = await Api.genericPost('/dados/rac_nc', {
                idep: globalStore.idep,
                idreferencia: obj.ref_id,
                strparam1: obj.ref_tabela});
            lsNc.value = rNc;
            showRacAberura.value = true;

        } else {
            idEdicao.value = obj.idrac;
            modoConferencia.value = (obj.cdstatus === 2 || obj.cdstatus === 3);
            modoEdicao.value = !modoConferencia.value;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>


<style scoped>
.rac-abertura {
    margin-top: 15px;
}

.rac-header {
    display: flex;
    gap: 15px;
    align-items: flex-start;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid #d7d7d7;
    border-radius: 8px;
    background: #f8f9fa;
    text-align: left;
}

.rac-header-icon {
    font-size: 28px;
    line-height: 1;
}

.rac-header h2 {
    margin: 0 0 5px 0;
    font-size: 20px;
}

.rac-header p {
    margin: 0;
    color: #555;
}

.rac-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-bottom: 5px;
}

.rac-card {
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.rac-card-header {
    padding: 10px 12px;
    background: #f2f4f7;
    border-bottom: 1px solid #dcdcdc;
}

.rac-card-codigo {
    font-size: 12px;
    font-weight: bold;
    color: #0d6efd;
    margin-bottom: 4px;
}

.rac-card-titulo {
    font-size: 14px;
    font-weight: 600;
}

.rac-textarea {
    width: 100%;
    border: none;
    resize: none;
    padding: 12px;
    background: white;
    font-size: 13px;
    line-height: 1.5;
    box-sizing: border-box;
}

.rac-textarea:focus {
    outline: none;
}

@media (max-width: 900px) {
    .rac-grid {
        grid-template-columns: 1fr;
    }
}
</style>